<template>
  <reset-password-component />
</template>

<script>
import ResetPasswordComponent from '../components/ResetPassword.vue'

export default {
  name: 'ResetPassword',
  components: {
    'reset-password-component': ResetPasswordComponent
  }
}
</script>
